import { render } from "./ProductDetail.vue?vue&type=template&id=5f593057"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=5f593057&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__